import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/wellness/dashboard.vue'

export default class extends Controller {
  static values = {
    userId: String,
    defaultPeriod: String,
    compareEnabled: Boolean
  }

  connect() {
    // Hide loading spinner
    const spinner = document.getElementById('loadingSpinner')
    if (spinner) {
      spinner.classList.add('hidden')
    }

    // Show Vue mount point
    this.element.classList.remove('hidden')

    const props = {
      userId: this.userIdValue,
      defaultPeriod: this.defaultPeriodValue || '7d',
      compareEnabled: this.compareEnabledValue || false
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
